/**
 * True when a test runner (or any WebDriver/CDP automation) drives this
 * browser. `navigator.webdriver` is the standard signal: Playwright sets it in
 * both bundled Chromium and Google Chrome (measured 2026-10-10), and so does
 * every WebDriver client.
 *
 * This replaced `window.Cypress`, which only Cypress ever set. After Cypress
 * was removed those guards were silently off under Playwright -- the dev login
 * panel was rendering into every test page.
 */
export const isAutomated = () => typeof navigator !== 'undefined' && navigator.webdriver === true;
